import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledEdit = styled.svg<IconProps>`
  & .cls-1 {
    fill: var(--du-color-grey, #969696);
  }

  &.hover:hover,
  &.active {
    &:not([disabled]) {
      .cls-1 {
        fill: var(--du-color-primary, #128370);
        stroke-width: 2.5;
      }
    }
  }
`;

const NextPageIcon: React.FC<IconProps> = ({ active, disabled }) => {
  let activeClass = active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeClass = `${activeClass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledEdit
      id='Edit-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeClass}
      disabled={disabled}
    >
      <g id='Component_116_1' data-name='Component 116 – 1' transform='translate(32 32) rotate(180)'>
        <rect id='Rectangle_4917' data-name='Rectangle 4917' width='32' height='32' fill='#fff' />
        <path
          id='Path_15862'
          data-name='Path 15862'
          d='M24.259,27.475,16.527,19.74,24.26,12,23,10.739l-9,9,9,9Z'
          transform='translate(-3 -4.239)'
          className='cls-1'
        />
      </g>
    </StyledEdit>
  );
};

export default NextPageIcon;
